import { render, staticRenderFns } from "./DocumentNumber.vue?vue&type=template&id=1fe0955a&"
import script from "./DocumentNumber.vue?vue&type=script&lang=js&"
export * from "./DocumentNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports